import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const PAYMENT_PLAN_ORDER_CREATE = `${API_URL}/payment_plan/order/create`;

export enum PaymentPlanOrderType {
  DEAL = "deal",
  TOUR = "tour",
}

interface PaymentPlanOrderPayload {
  productName: string;
  productPrice: number;
  customerEmail: string;
  numberOfWeeks: number;
  depositAmount: number;
  departureDate: string;
  currency: string;
  type: PaymentPlanOrderType;
}

interface PaymentPlanOrderResponse {
  success: boolean;
  orderId?: string;
  message?: string;
}

export const createPaymentPlanOrder = async (
  payload: PaymentPlanOrderPayload
): Promise<PaymentPlanOrderResponse> => {
  try {
    const response = await axios.post<PaymentPlanOrderResponse>(
      PAYMENT_PLAN_ORDER_CREATE,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error creating payment plan order:", error);
    throw error;
  }
};